<script lang="ts">
	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();
	export let selected = false;
</script>

<div
	class:selected
	on:click={() => dispatch("click", { isSelected: selected })}
>
	<slot />
</div>

<style>
	div {
		box-sizing: border-box;
		border: 1px solid var(--button);
		border-radius: 60px;
		background: rgba(0, 0, 0, 0);
		color: var(--text);
		margin: 0.75rem;
		padding: 0.5rem;
		cursor: pointer;
	}
	.selected {
		background: var(--button);
		color: var(--background);
	}
</style>
